export default "__VITE_ASSET__WMPw0nzo__"